import React from 'react';

const HelpCenterView = () => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl mx-auto my-8">
            <h1 className="text-3xl font-bold text-sky-700 mb-6">Help Center</h1>
            
            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    <div>
                        <h3 className="font-bold text-teal-600">How do I order medicines?</h3>
                        <p className="text-gray-600">You can order by searching for products in our store, uploading a prescription, or contacting us directly via WhatsApp or Phone.</p>
                    </div>
                    <div>
                        <h3 className="font-bold text-teal-600">Is a prescription mandatory?</h3>
                        <p className="text-gray-600">For scheduled drugs (Rx), a valid prescription from a registered medical practitioner is mandatory by law.</p>
                    </div>
                    <div>
                        <h3 className="font-bold text-teal-600">How long does delivery take?</h3>
                        <p className="text-gray-600">Most orders are delivered within 24-48 hours depending on your location in Navi Mumbai.</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Contact Support</h2>
                <p className="text-gray-600 mb-2">Still need help? Reach out to us:</p>
                <ul className="list-disc ml-6 text-gray-600">
                    <li>Phone: +91 90291 22955</li>
                    <li>WhatsApp: +91 90291 22955</li>
                    <li>Email: support@qwickmed.com</li>
                </ul>
            </section>
        </div>
    );
};

export default HelpCenterView;
